module.exports = __webpack_public_path__ + "static/img/gas.36f9858c.png";